module.exports = __webpack_public_path__ + "images/csv-import.23422088e84c94a22030862754e97675.png";